import type { FC } from 'react';

import { GlobalStyles as MuiGlobalStyles } from '@mui/material';

import { theme } from 'shared/theme';

// The theme comes from the module, not the provider: these are the page's baseline rules
// (Tailwind's preflight is off), so they have to render even when the surrounding MUI
// instance isn't the one this file's imports resolve to.
export const GlobalStyles: FC = () => (
  <MuiGlobalStyles
    styles={{
      '*': {
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
      },
      'html': {
        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
        'height': '100%',
        'width': '100%',
      },
      'body': {
        height: '100%',
        width: '100%',
        fontFamily: theme.typography.fontFamily,
      },
      '#root': {
        height: '100%',
        width: '100%',
        position: 'relative',
      },
    }}
  />
);
